// @ts-nocheck
'use strict';
import $ from 'jquery';
import { getCookie } from './utils/get_cookie.js';

var currentIndex = 0;
let samplePages = JSON.parse($('#book_pics_str').text());
console.log('dddd');

function updateModalImage() {
  var modalImage = $('.modal-image');
  modalImage.attr('src', samplePages[currentIndex]);

  $('.prev-btn').toggle(currentIndex !== 0);
  $('.next-btn').toggle(currentIndex !== samplePages.length - 1);
}

function setUpUI() {
  $('.lesson').on('click', function () {
    window.location.href = `/video/${$(this).attr('lid')}`;
  });

  $('.sample-page').each(function (index) {
    $(this).on('click', function () {
      currentIndex = index;
      updateModalImage();
      $('#imageModal').modal('show');
    });
  });

  $('.prev-btn').on('click', function () {
    if (currentIndex > 0) {
      currentIndex--;
      updateModalImage();
    }
  });

  $('.next-btn').on('click', function () {
    if (currentIndex < samplePages.length - 1) {
      currentIndex++;
      updateModalImage();
    }
  });

  $('#go_order').on('click', function () {
    window.location.href = '/book_order';
  });
}

setUpUI();
